import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5fe06e43"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "methods is-flex" }
const _hoisted_2 = {
  class: "field has-addons",
  style: {"width":"110px"}
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "control" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "button is-static" }, "View")
], -1))
const _hoisted_4 = { class: "control" }
const _hoisted_5 = {
  class: "field has-addons",
  style: {"width":"140px"}
}
const _hoisted_6 = { class: "control" }
const _hoisted_7 = { class: "control" }
const _hoisted_8 = {
  class: "field has-addons",
  style: {"width":"140px"}
}
const _hoisted_9 = { class: "control" }
const _hoisted_10 = { class: "control" }
const _hoisted_11 = {
  class: "field has-addons",
  style: {"width":"140px"}
}
const _hoisted_12 = { class: "control" }
const _hoisted_13 = { class: "control" }
const _hoisted_14 = {
  class: "field has-addons",
  style: {"width":"160px"}
}
const _hoisted_15 = { class: "control" }
const _hoisted_16 = { class: "control" }
const _hoisted_17 = { class: "field has-addons" }
const _hoisted_18 = { class: "control" }
const _hoisted_19 = { class: "control" }
const _hoisted_20 = { class: "field has-addons" }
const _hoisted_21 = { class: "control" }
const _hoisted_22 = { class: "control" }
const _hoisted_23 = { class: "field has-addons" }
const _hoisted_24 = { class: "control" }
const _hoisted_25 = { class: "control" }
const _hoisted_26 = { class: "field has-addons" }
const _hoisted_27 = { class: "control" }
const _hoisted_28 = { class: "control" }
const _hoisted_29 = { class: "control" }
const _hoisted_30 = { class: "control" }
const _hoisted_31 = { class: "field has-addons" }
const _hoisted_32 = { class: "control" }
const _hoisted_33 = { class: "control" }
const _hoisted_34 = { class: "control" }
const _hoisted_35 = { class: "control" }
const _hoisted_36 = { class: "tile is-ancestor" }
const _hoisted_37 = { class: "tile is-10 is-vertical is-parent" }
const _hoisted_38 = { class: "viewer-wrapper" }
const _hoisted_39 = { class: "images" }
const _hoisted_40 = ["src", "data-source", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Flicking = _resolveComponent("Flicking")!
  const _component_viewer = _resolveComponent("viewer")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.options.inline)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("div", _hoisted_4, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.view) = $event)),
                  class: "input",
                  type: "text",
                  onKeyup: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.view && _ctx.view(...args)))
                }, null, 544), [
                  [
                    _vModelText,
                    _ctx.form.view,
                    void 0,
                    { number: true }
                  ]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.zoom) = $event)),
                  class: "input",
                  type: "text"
                }, null, 512), [
                  [
                    _vModelText,
                    _ctx.form.zoom,
                    void 0,
                    { number: true }
                  ]
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("span", {
                  class: "button",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.zoom()))
                }, "Zoom")
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.zoomTo) = $event)),
                  class: "input",
                  type: "text"
                }, null, 512), [
                  [
                    _vModelText,
                    _ctx.form.zoomTo,
                    void 0,
                    { number: true }
                  ]
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("span", {
                  class: "button",
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.zoomTo && _ctx.zoomTo(...args)))
                }, "Zoom to")
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.rotate) = $event)),
                  class: "input",
                  type: "text"
                }, null, 512), [
                  [
                    _vModelText,
                    _ctx.form.rotate,
                    void 0,
                    { number: true }
                  ]
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("span", {
                  class: "button",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.rotate()))
                }, "Rotate")
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.rotateTo) = $event)),
                  class: "input",
                  type: "text"
                }, null, 512), [
                  [
                    _vModelText,
                    _ctx.form.rotateTo,
                    void 0,
                    { number: true }
                  ]
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("span", {
                  class: "button",
                  onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.rotateTo && _ctx.rotateTo(...args)))
                }, "Rotate to")
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("button", {
                  type: "button",
                  class: "button",
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.zoom(0.5)))
                }, " Zoom In ")
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("button", {
                  type: "button",
                  class: "button",
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.zoom(-0.5)))
                }, " Zoom Out ")
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("button", {
                  type: "button",
                  class: "button",
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.rotate(-90)))
                }, " Rotate Left ")
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("button", {
                  type: "button",
                  class: "button",
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.rotate(90)))
                }, " Rotate Right ")
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("button", {
                  type: "button",
                  class: "button",
                  onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.scaleX()))
                }, " Flip Horizontal ")
              ]),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("button", {
                  type: "button",
                  class: "button",
                  onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.scaleY()))
                }, " Flip Vertical ")
              ])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("button", {
                  type: "button",
                  class: "button",
                  onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.move(-10, 0)))
                }, " Left ")
              ]),
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("button", {
                  type: "button",
                  class: "button",
                  onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.move(10, 0)))
                }, " Right ")
              ]),
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("button", {
                  type: "button",
                  class: "button",
                  onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.move(0, -10)))
                }, " Up ")
              ]),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("button", {
                  type: "button",
                  class: "button",
                  onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.move(0, 10)))
                }, " Down ")
              ])
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("button", {
                  type: "button",
                  class: "button",
                  onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.prev && _ctx.prev(...args)))
                }, " Prev ")
              ]),
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("button", {
                  type: "button",
                  class: "button",
                  onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.next && _ctx.next(...args)))
                }, " Next ")
              ]),
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("button", {
                  type: "button",
                  class: "button",
                  onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.play && _ctx.play(...args)))
                }, " Play ")
              ]),
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("button", {
                  type: "button",
                  class: "button",
                  onClick: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.stop && _ctx.stop(...args)))
                }, " Stop ")
              ])
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "button",
              onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.full && _ctx.full(...args)))
            }, " Full "),
            _createElementVNode("button", {
              type: "button",
              class: "button",
              onClick: _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => (_ctx.tooltip && _ctx.tooltip(...args)))
            }, " Tooltip "),
            _createElementVNode("button", {
              type: "button",
              class: "button",
              onClick: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.reset && _ctx.reset(...args)))
            }, " Reset ")
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_36, [
      _createElementVNode("div", _hoisted_37, [
        _createElementVNode("div", _hoisted_38, [
          _createVNode(_component_viewer, {
            ref: "viewer",
            options: _ctx.options,
            images: _ctx.images,
            rebuild: "",
            class: "viewer",
            onInited: _ctx.inited
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("figure", _hoisted_39, [
                _createVNode(_component_Flicking, {
                  plugins: _ctx.plugins,
                  options: { align: 'prev', circular: true },
                  onMoveEnd: _ctx.onMoveEnd
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.images, ({source, thumbnail, title}) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: source,
                        class: "image-wrapper panel"
                      }, [
                        _createElementVNode("img", {
                          class: "image",
                          src: thumbnail,
                          "data-source": source,
                          alt: title
                        }, null, 8, _hoisted_40)
                      ]))
                    }), 128))
                  ]),
                  _: 2
                }, 1032, ["plugins", "onMoveEnd"])
              ])
            ]),
            _: 1
          }, 8, ["options", "images", "onInited"])
        ])
      ])
    ])
  ]))
}